export enum CartAction {
  DeleteItem = 'deleteItem',
}
